module.exports = __webpack_public_path__ + "static/img/hero-info-4.95a2d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/h5/imgs/hero-info-4.png
// module id = TK4N
// module chunks = 13